import { DefaultSuggestion } from '../../../contracts';

const trendingModels: DefaultSuggestion[] = [
  {
    text: 'Chevrolet Bolt',
    filters: {
      makes: [{ name: 'Chevrolet', parentModels: [{ name: 'Bolt' }] }]
    }
  },
  {
    text: 'Toyota Camry',
    filters: {
      makes: [{ name: 'Toyota', parentModels: [{ name: 'Camry' }] }]
    }
  },
  {
    text: 'Jeep Grand Cherokee',
    filters: {
      makes: [{ name: 'Jeep', parentModels: [{ name: 'Grand Cherokee' }] }]
    }
  },
  {
    text: 'Tesla Model 3',
    filters: {
      makes: [{ name: 'Tesla', parentModels: [{ name: 'Model 3' }] }]
    }
  },
  {
    text: 'Ford Mustang',
    filters: {
      makes: [{ name: 'Ford', parentModels: [{ name: 'Mustang' }] }]
    }
  },
  {
    text: 'Honda Accord',
    filters: {
      makes: [{ name: 'Honda', parentModels: [{ name: 'Accord' }] }]
    }
  },
  {
    text: 'Dodge Challenger',
    filters: {
      makes: [{ name: 'Dodge', parentModels: [{ name: 'Challenger' }] }]
    }
  },
  {
    text: 'Honda Civic',
    filters: {
      makes: [{ name: 'Honda', parentModels: [{ name: 'Civic' }] }]
    }
  },
  {
    text: 'Nissan Altima',
    filters: {
      makes: [{ name: 'Nissan', parentModels: [{ name: 'Altima' }] }]
    }
  },
  {
    text: 'Ford Explorer',
    filters: {
      makes: [{ name: 'Ford', parentModels: [{ name: 'Explorer' }] }]
    }
  },
  {
    text: 'Chevrolet Equinox',
    filters: {
      makes: [{ name: 'Chevrolet', parentModels: [{ name: 'Equinox' }] }]
    }
  }
];

export default trendingModels;
